import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { BarChartConfig } from '../../types/executiveChat';
import './ChartCard.css';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface BarChartCardProps {
  config: BarChartConfig;
}

const BarChartCard: React.FC<BarChartCardProps> = ({ config }) => {
  // Extract labels from data
  const labels = config.data.map(item => item[config.xAxisKey]);

  // Build datasets from bars configuration
  const datasets = config.bars.map(bar => ({
    label: bar.name,
    data: config.data.map(item => item[bar.dataKey]),
    backgroundColor: bar.color + 'CC', // Add some transparency
    borderColor: bar.color,
    borderWidth: 1,
    borderRadius: 6,
    barThickness: config.horizontal ? undefined : 40,
    maxBarThickness: 60
  }));

  const chartData = {
    labels,
    datasets
  };

  const options = {
    indexAxis: config.horizontal ? ('y' as const) : ('x' as const),
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          usePointStyle: true,
          padding: 15,
          font: {
            size: 12,
            family: "'Inter', sans-serif"
          }
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: 12,
        titleFont: {
          size: 13,
          weight: 'bold' as const
        },
        bodyFont: {
          size: 12
        },
        callbacks: {
          label: function(context: any) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            const value = context.parsed.y || context.parsed.x;
            // Format large numbers with commas
            label += value.toLocaleString();
            return label;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value: any) {
            // Format large numbers
            if (value >= 1000000) {
              return (value / 1000000).toFixed(1) + 'M';
            } else if (value >= 1000) {
              return (value / 1000).toFixed(0) + 'K';
            }
            return value;
          },
          font: {
            size: 11
          }
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        ticks: {
          font: {
            size: 11
          }
        },
        grid: {
          display: config.horizontal ? true : false,
          color: 'rgba(0, 0, 0, 0.05)'
        }
      }
    }
  };

  return (
    <div className="exec-chart-card">
      {config.title && <h3 className="exec-chart-title">{config.title}</h3>}
      <div className="exec-chart-container">
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default BarChartCard;














